import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const search = z.object({
  action: z.literal("new").optional(),
});

export const Route = createFileRoute("/uns/uns-builder/")({
  staticData: {
    title: "navigation.unsBuilder",
  },
  validateSearch: search,
});
